module.exports = __webpack_public_path__ + "static/simplified-ui-small-video.b52a35e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simplified-ui-small-video.png
// module id = 674
// module chunks = 168707334958949